import React from 'react';
import { connect } from 'react-redux';
import { fetchEventDetails } from '../../actions/event';
import { sessionCheck } from '../../actions/user';
import Logger from '../../util/Logger';
import Event from '../../models/Event';
import { EventQuestionType } from '../../models/EventQuestionType';
import './HeroRibbon.css';
import { NavigationUtils } from '../../util/NavigationUtils';
import { TopBarVisibility } from '../layout/TopBarVisibility';
import Tooltip from '../shared/Tooltip';
import { CreatorRibbonAnalytics } from '../../analytics/CreatorRibbonAnalytics';
import $ from 'jquery';
import _ from 'lodash';
import { PayMeMoney } from '../../money/PayMeMoney';
import PayMeModal from '../../money/PayMeModal';
import { ScreenRecorder } from '../../util/ScreenRecorder';
// import FeatureRequestDialog from '../shared/FeatureRequestDialog';

class HeroRibbon extends React.Component {

  constructor (props) {
    super(props);

    const { user } = props;
    if (!user) {
      Logger.assert('Missing user in HeroRibbon component');
    }
  }

  render () {
    const {
      user, event, editing, collection,
      onEditModeClicked, onDownloadClicked, redirectedFromAngular
    } = this.props;
    if (!event || editing) {
      return null;
    } else {
      // Load event view
      if (TopBarVisibility.isShowingHeroRibbon(event)) {
        return <Ribbon
          user={ user }
          event={ event }
          collection={ collection }
          onEditModeClicked={ onEditModeClicked }
          onDownloadClicked={ onDownloadClicked }
          redirectedFromAngular={redirectedFromAngular}
        />;
      } else {
        // Hide ribbon for not user created
        return null;
      }
    }
  }

}

class Ribbon extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      showPayMeMoney : false,
      whyPay: null
    };
  }

  handleOnDownloadClicked = () => {
    if (this.canExport()) {
      const { onDownloadClicked } = this.props;
      ScreenRecorder.trackCustomAction('DOWNLOAD_CLICKED');
      onDownloadClicked();
    } else {
      Logger.warn('Export clicked but disabled');
      this.setState({ showPayMeMoney : true, whyPay: 'export' });
    }
  };

  handleBarTitleLeftClicked = ($event) => {
    CreatorRibbonAnalytics.creatorRibbTab('POPin');
    ScreenRecorder.trackCustomAction('BACK_TO_POPIN_CLICKED');
    this.backToLegacyPage($event);
  };
  onResultClicked = () => {
    CreatorRibbonAnalytics.creatorRibbTab('Results');
  };

  backToLegacyPage = ($event) => {
    $event.preventDefault();

    const { event } = this.props;
    const slug = Event.getSlug(event);
    if (slug) {
      NavigationUtils.routeToLegacy(`/q/${slug}/answers?fromreport=1`);
    }
  };

  hideTooltip = () => {
    const element = $(`#popin-tab`);
    element.tooltip('hide');
  };

  onCustomizeClicked = ($event) => {  
    if (this.canCustomize()) {
      const { onEditModeClicked } = this.props;
      ScreenRecorder.trackCustomAction('CUSTOMIZE_ENTERED');
      onEditModeClicked($event);
    } else {
      Logger.warn('Customize clicked but disabled');
      this.setState({ showPayMeMoney : true, whyPay: 'customize' });
    }
  }

  onHideModal = () => {
    this.setState({ showPayMeMoney : false, whyPay: null });
  }

  canCustomize = () => {
    const { user, event } = this.props;
    return (_.get(user, 'plan.features.custom_reports') && !EventQuestionType.isMultipleRatingType(event.question_type)) || false;
  }

  canExport = () => {
    const { user } = this.props;
    return _.get(user, 'plan.features.data_exports') || false;
  }

  render () {
    const { showPayMeMoney, whyPay } = this.state;
    const { user, redirectedFromAngular } = this.props;
    const offsetClass = TopBarVisibility.isViewingAs(user) ? 'viewing-as-offset' : '';
    return (
      <div className={ `row no-gutters hero-ribbon fixed-top d-print-none ${offsetClass}` }>
        <div className="container">
          <div className="content h-100">
            <div className="row no-gutters h-100 d-flex align-items-center">
              <div
                className="ribbon-item px-2 mx-auto popin-tab"
                onClick={ this.handleBarTitleLeftClicked }>
                <Tooltip tooltip="Click here to relaunch" placement="left" id={`${redirectedFromAngular ? 'popin-tab' : ''}`} callback={ this.hideTooltip }>
                  POPin
                </Tooltip>

              </div>

              <div className="v-divider" />

              <div className="ribbon-item-selected px-2 mx-auto" onClick={ this.onResultClicked }>
                RESULTS
              </div>

              <div className="fix-ie" />

              { this.canCustomize() && <div
                className="ribbon-item px-2"
                onClick={ this.onCustomizeClicked }>
                <div className="h-100 m-auto">
                  <Tooltip tooltip="Customize your Report" placement="bottom">
                    <i className="material-icons customize-icon" title="Customize">dashboard</i>
                  </Tooltip>
                  <div className="ribbon-item-label display-if-medium">Customize</div>
                </div>
              </div>}

              {/* NOT WORKING - don't know why
                { !this.canCustomize() && <div
                className="ribbon-item px-2"
                data-toggle="modal" data-target="#resultsCustomization">
                <div className="h-100 m-auto">
                  <Tooltip tooltip="Customize your Report" placement="bottom">
                    <i className="material-icons customize-icon" title="Customize">dashboard</i>
                  </Tooltip>
                  <div className="ribbon-item-label display-if-medium">Customize</div>
                </div>
                <FeatureRequestDialog id="resultsCustomization"/>
              </div>} */}

              <div
                className="ribbon-item px-2"
                onClick={ this.handleOnDownloadClicked }>
                <div className="h-100 m-auto">
                  <Tooltip tooltip="Export your Report as a PDF or CSV" placement="bottom">
                    { !this.canExport() && <PayMeMoney user={ user } upgrade={ true } /> }
                    <i className="material-icons export-report-icon" title="Export Report">insert_drive_file</i>
                  </Tooltip>
                  <div className="ribbon-item-label display-if-medium">Export Report</div>
                </div>
              </div>

            </div>
          </div>
        </div>

        { showPayMeMoney && (
          <PayMeModal
            user={ user }
            upsell={
             !!whyPay
               ? whyPay === 'export'
                 ? `Your ${_.get(user, 'plan.name') || 'Plan'} does not include Report Exporting`
                 : `Your ${_.get(user, 'plan.name') || 'Plan'} does not include Report Customization`
               : null
            }
            openedFrom={
              !!whyPay
                ? whyPay === 'export'
                  ? 'POPin Report Exporting'
                  : 'POPin Report Customization'
                : null
             }
            onHidden={ this.onHideModal } />
        ) }

      </div>
    );
  }
}

const mapStateToProps = state => {
  const user = state.user.user;
  return {
    user: user,
    loadingEvent: state.event.loading,
    eventError: state.event.error,
    pdfLoading: state.pdf.loading,
    pdfError: state.pdf.error,
    pdfDownloadUrl: state.pdf.pdfDownloadUrl
    // event and collection are passed in from parent component
  };
};

export default connect(mapStateToProps, { fetchEventDetails, sessionCheck })(HeroRibbon);
